/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { openlightbox } from "../../util/Functions";
import { ThemeProvider } from "@mui/material/styles";
import { Paper, Typography } from "@mui/material";
import { TaskAlt, Visibility } from "@mui/icons-material";
import { theme, customStyles } from "../../util/TableStyles";
import { noDataComponent } from "../../util/DataObject";
import { useStyles } from "../../util/ComponentStyles";
import InfoValidation from "../modals/InfoValidation";
import DataTable from "react-data-table-component";
import moment from "moment";
import "moment/locale/es";

const statusParse = (status) => {
  let parse = "";
  switch (status) {
    case "invalidated":
      parse = "Bloqueado";
      break;
    case "rejected":
      parse = "Rechazado";
      break;
    case "validated":
      parse = "Validado";
      break;
    default:
      parse = status;
      break;
  }
  return parse;
};

const ValidationsList = (props) => {
  moment.locale("es");
  const history = useHistory();
  const clasess = useStyles();
  const [data, setData] = useState([]);
  const [limit, setLimit] = useState(0);
  const [uuid, setUuid] = useState("");
  const [name, setName] = useState("");
  const columns = [
    {
      cell: (item) => {
        return (
          <div>
            <a href="#" data-tag="allowRowEvents" onClick={findDataAgent.bind(this, item)} >
              <Visibility />
            </a>
          </div>
        );
      },
      sortable: true, maxWidth: "50px", minWidth: "50px"},
    { selector: (row) => row.hasOwnProperty("result") ? statusParse(row.result.status ? row.result.status : "N/A") : "N/A",
      name: "Estatus", minWidth: "20%", sortable: true, wrap: true},
    { selector: (row) => row.hasOwnProperty("result") ? row.result.reason ? row.result.reason : "N/A" : "N/A",
      name: "Razón", minWidth: "20%", sortable: true, wrap: true },
    { selector: (row) => row.hasOwnProperty("result") ? row.result.comment ? row.result.comment : row.result.cooment ? row.result.cooment : "N/A" : "N/A",
      name: "Comentarios", minWidth: "30%", sortable: true, wrap: true},
    { selector: (row) => moment(new Date(row.cdate)).format("LLL"),
      name: "Fecha validación", minWidth: "20%", sortable: true, wrap: true},
  ];
  useEffect(() => {
    init();
  }, [props.content]);

  const init = () => {
    if (props.content) {
      if (props.content.results) {
        setData(JSON.parse(JSON.stringify(props.content.results)));
      }
      if (props.content.hasOwnProperty("limit")) {
        setLimit(props.content.limit);
      }
      if (props.content.uuid) {
        setUuid(props.content.uuid);
      }
      if (props.content.name) {
        setName(props.content.name);
      }
    }
  };

  const findDataAgent = async (item) => {
    props.changeLoader(true);
    let data = {
      uuid: item.agent_uuid,
    };
    let request = await API.service( "findAgent", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (request.status == 200 && request.data.data.response == "OK") {
      if (request.data.data.content.uuid) {
        const as = (
          <InfoValidation
            name={name}
            content={request.data.data.content}
            files={item.hasOwnProperty("result") ? item.result.files ? item.result.files : [] : [] }
            changeLoader={props.changeLoader}
            pos={props.pos}
            changeAlert={props.changeAlert}
            history={history}
          />
        );
        openlightbox(as);
      }
    }
    props.changeLoader(false);
  };

  const findValidations = async (data) => {
    props.changeLoader(true);

    let request = await API.service( "findValidations", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (request.status == 200 && request.data.data.response == "OK") {
      let newWidgets = [];
      let existe = false;
      for (let i = 0; i < props.widgets.length; i++) {
        if (props.widgets[i]["type"] == "validationsList") {
          newWidgets.push(request.data.data.widget[0]);
          existe = true;
        } else {
          newWidgets.push(props.widgets[i]);
        }
      }

      if (!existe) {
        newWidgets = [request.data.data.widget[0]].concat(newWidgets);
      }
      props.changeWidgets(newWidgets);
    }
    props.changeLoader(false);
  };

  const changePage = async (value) => {
		let data = {
      uuid: uuid,
			page: value,
			limit: limit,
			name: name
		}
    await findValidations(data);
	};

  const paginationComponentOptions = {
    rangeSeparatorText: "de",
    noRowsPerPage: true,
  };

  return (
    <Paper className={clasess.validationList}>
      <Typography
        component="div"
        children={
          <div className={clasess.titleTable}>
            <h3 className={clasess.titleH2_1}>
              <TaskAlt className={clasess.iconTitle2} />
              <span>Validaciones Manuales</span>
            </h3>
          </div>
        }
      />
      <div style={{ maxHeight: 400, width: "100%" }}>
        <ThemeProvider theme={theme}>
          <DataTable
            data={data}
            columns={columns}
            pagination
            paginationServer
            paginationComponentOptions={paginationComponentOptions}
            paginationTotalRows={props.content.total}
            onChangePage={changePage}
            paginationPerPage={props.content.limit}
            noDataComponent={noDataComponent}
          />
        </ThemeProvider>
      </div>
    </Paper>
  );
};

export default ValidationsList;
